export enum PartnerProfileEnum {
  PARTNER_PROFILE_SERVICES_BUTTON = 'partner-profile--services-button',
  PARTNER_REDIRECT_MODAL_TITLE = 'partner-redirect-modal--title',
  PARTNER_REDIRECT_MODAL_CLOSE_BUTTON = 'partner-redirect-modal--close-button',
  PARTNER_REDIRECT_MODAL_TEXT = 'partner-redirect-modal--text',
  PARTNER_REDIRECT_MODAL_LINK_REDIRECT = 'partner-redirect-modal--link-redirect',
  PARTNER_PROFILE_SECTION_SPECIALTIES = 'partner-profile--specialties',
  PARTNER_PROFILE_SECTION_STRUCTURE = 'partner-profile--section-structure',
  PARTNER_PROFILE_SECTION_ADDRESS = 'partner-profile--section-address',
  PARTNER_PROFILE_SECTION_PROFESSIONALS = 'partner-profile--section-professionals',
  PARTNER_PROFILE_SECTION_RATING = 'partner-profile--section-rating',
  PARTNER_PROFILE_GALLERY_IMAGE = 'gallery-image--gallery-component',
}
